export default {
    post(h, url, sendData, onSuccess, onError) {
        h.post(url, sendData)
            .then(
                res => res.json().then(
                    onSuccess,
                    onError
                ),
                onError
            );
    },
    put(h, url, id, sendData, onSuccess, onError) {
        h.put(`${url}/${id}`, sendData)
            .then(
                res => res.json().then(
                    onSuccess,
                    onError
                ),
                onError
            );
    },
    get(h, url, onSuccess, onError) {
        h.get(url)
            .then(
                res => res.json().then(
                    onSuccess,
                    onError
                ),
                onError
            );
    }
};